import React from 'react'

import {Img} from 'react-image'

import { useStaticQuery, graphql, Link, withPrefix } from "gatsby"

import arrow from "../images/arrow_right_black.svg"

import {
    container,
    title as titleStyle,
    link as linkStyle,
    linksContainer,
    linkContainer,
    linkCheckmark,
    titleSmall,
    linkSimple,
    containerSmall,
    seeMoreButton
} from "./SummaryBlock.module.css"

export default function SummaryBlock({ section, maxPosts = 3, type, sectionTitle }) {

    function removeTrailingSlash(url) {
        if (url.endsWith('/')) {
            return url.slice(0, -1);
        }
        return url;
    }

    const queryData = useStaticQuery(graphql`
        query {
            allMdx(sort: {frontmatter: {weight: DESC}}) {
                edges {
                    node {
                        id
                        frontmatter {
                            post_title
                            dir
                            weight
                        }
                        fields {
                            slug
                        }
                        body
                        excerpt(pruneLength: 210)
                    }
                }
            }
        }
    `)   

    
    // get nodes related to provided section
    let sectionNodes = queryData.allMdx.edges.filter( ({node}) => node.fields.slug.startsWith(`/${section}/`));
    // make sure we don't include the post that represent the section itself
    sectionNodes = sectionNodes.filter( ({node}) => node.fields.slug !== `/${section}/`);

    // get section node
    const sectionNode = queryData.allMdx.edges.filter( ({node}) => node.fields.slug === `/${section}/`)[0];
    // const sectionNodeTitle = sectionNode.node.frontmatter.post_title
    const sectionNodeTitle = sectionNode.node.frontmatter.dir

    //console.log("sectionNode.node.fields.slug: ", sectionNode.node.fields.slug)
    //const iconUrl = sectionNode.node.fields.slug.slice(1, -1).split('/')[0]
    const iconEndingUrl = type === "small" ? "_small.svg" : "_big.svg";
    const iconUrl = removeTrailingSlash(sectionNode.node.fields.slug)
    const iconFullUrl = withPrefix(`/images/docs${iconUrl}${iconEndingUrl}`)

    // filter down level nodes
    // section  /tutorials/storage/
    // keep     /tutorials/storage/qencode-storage/
    // remove   /tutorials/storage/qencode-storage/bucket-limits/
    sectionNodes = sectionNodes.filter( ({node}) => node.fields.slug.replace(`${section}/`,'').split('/').length-1 === 2);

    let sectionPosts = sectionNodes.map( ({ node }) => {
        return {
            // title: node.frontmatter.post_title, 
            title: node.frontmatter.dir, 
            url: node.fields.slug
        }
    })

    // if there are no posts inside section, try to make links based on h2 titles
    if(sectionNodes.length === 0 && sectionNode){
        // console.log("Get posts links from single page for ", section)
        // console.log("sectionNode: ", sectionNode)

        let pageSections = []

        // let rawMarkDown = node.rawBody
        let rawMarkDown = sectionNode.node.body
        let lines = rawMarkDown.split('\n');

        let titles = lines.filter(line => line.startsWith('## ')).reverse()
        //console.log("titles: ", titles)

        // 1. we find last title in the page and copy everything starting from it to the end to new section
        // 2. after that we remove title and everything below it from the text and repeat step 1

        titles.forEach(title => {

            let titleIndex = rawMarkDown.indexOf(title)                    
            let section = rawMarkDown.substring(titleIndex, rawMarkDown.length)

            let sectionContent = section.substring(title.length, section.length).replace(/<[^>]+>/g, '') // remove all tags 
            let sectionTitle = title.substring(3, title.length);
           
            pageSections.push({
                id: sectionTitle.toLowerCase().split(' ').join('-').replace(/\./g,''), // id must match id generated for h2 tag, remove all dots
                title: sectionTitle,
                content: sectionContent
            })
            
            rawMarkDown = rawMarkDown.substring(0, titleIndex);
        })

        pageSections.reverse()      
        

        sectionPosts = pageSections.map( ({ title, id }) => {
            return {
                title: title, 
                url: sectionNode.node.fields.slug + "#" + id
            }
        })
    
    }    

    const sectionPostsComponent = sectionPosts.slice(0, maxPosts).map((post, index) => 
        <div className={linkContainer} key={index}>
            <Link className={`${linkStyle} ${type === "small" ? linkSimple : ''}`} to={post.url}>
                <svg className={linkCheckmark} xmlns="http://www.w3.org/2000/svg" width="12" height="10" viewBox="0 0 12 10" fill="none">
                    <path d="M11 1L4.125 8.5L1 5.09091" stroke="#316FEA" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
                <span>{post.title}</span>
            </Link>            
        </div>
    );
  

    return(       
        <div className={`${container} ${type === "small" ? containerSmall : ''}`}>      
            <div className={`${titleStyle} ${type === "small" ? titleSmall : ''}`}>
                {/* <img src={iconFullUrl} alt="" /> */}
                <Img
                    src={[iconFullUrl, null]}
                    alt=''
                /> 
                {/* <span>{sectionNodeTitle}</span> */}
                {
                    sectionTitle
                    ? <span>{sectionTitle}</span>
                    : <span>{sectionNodeTitle}</span>
                }
                
            </div>
            <div className={linksContainer}>{sectionPostsComponent}</div>
            { type === "small" &&
                <Link className={seeMoreButton} to={`${section}/`}>
                    <span>View More</span>
                    <img src={arrow} alt="" />
                </Link>  
            }
        </div>
    )
}
